// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import KLRound1 from '../components/KLRound1';
import KLRound2 from '../components/KLRound2';
import KLRound3 from '../components/KLRound3';
import KLRound4 from '../components/KLRound4';
import selectKLAnyRoundProps from '../selectors/specifics/selectKLAnyRoundProps';
import { type KLRound, KLRounds } from '../types/round';

const KLRoundViewsByRoundId = {
  [KLRounds.T_RED]: KLRound1,
  [KLRounds.T_WHITE]: KLRound2,
  [KLRounds.ORIENTATION]: KLRound3,
  [KLRounds.POLE]: KLRound4,
};

type KLRoundContainerProps = {
  className?: string;
  roundId: KLRound;
};

const KLRoundContainer = ({ roundId, ...ownProps }: KLRoundContainerProps) => {
  const DynamicKLRound = useMemo(() => KLRoundViewsByRoundId[roundId], [roundId]);

  const selectorProps = useMemo(() => ({ roundId }), [roundId]);
  const selectedProps = useSelector((state) => selectKLAnyRoundProps(state, selectorProps));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <DynamicKLRound {...enhancedProps} />;
};

export default KLRoundContainer;
